import { useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import { Button } from "@mui/material";
import { Container } from "@mui/material";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import {
  StyledCardContent,
  StyledChoiceFileText,
  StyledUploadBox,
  StyledContainerBox,
} from "./Add.style";
import { ImUpload } from "react-icons/im";
import { addTicketRequest } from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import FormHelperText from "@mui/material/FormHelperText";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AddTicketSchema } from "validations";
import Toast from "helper/toast";
import CheckIcon from "@mui/icons-material/Check";
import BackButton from "components/shared/BackButton";
import {Helmet} from "react-helmet";

////////////////////////////
const formList = [
  {
    label: "موضوع",
    type: "text",
    id: "title",
  },
  {
    label: "شرح تیکت",
    type: "text",
    id: "text",
  },
];

export default function Addaddress() {
  const { request, loading } = useHttp(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(AddTicketSchema),
  });
  const [file, setFile] = useState("");

  const onSubmit = async (values) => {
    const res = await request({
      url: addTicketRequest,
      values,
    });
    if (res) {
      reset({
        title: "",
        text: "",
        file: "",
      });
      navigate(-1);
      Toast({ type: "success", title: "ثبت تیکت" });
    }
  };

  return (
    <>
      <Helmet>
        <title>پشتیبانی - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <>
          <MenuCM Background pageTitle="تیکت جدید" />
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <ProfileMenuCM />
              </Grid>
              <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
                <Paper p={2}>
                  <StyledCardContent>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "21px",
                      }}
                    >
                      تیکت جدید
                    </Typography>
                  </StyledCardContent>
                  <CardContent>
                    <Grid
                      container
                      style={{ paddingLeft: "30px", direction: "rtl" }}
                    >
                      <Grid item mt={3} mb={3} xs={12}>
                        <BackButton />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      {formList.map((items, index) => (
                        <Grid
                          item
                          md={12}
                          xs={12}
                          // p={1.5}
                          key={"profile" + index}
                        >
                          <TextField
                            id={items.id}
                            label={items.label}
                            variant="outlined"
                            required={items.required}
                            fullWidth
                            {...register(items.id)}
                            readOnly={items.readOnly}
                            error={Boolean(errors[items.id])}
                            multiline={items.id == "text" ? true : false}
                            rows={items.id == "text" ? 4 : 1}
                          />
                          <FormHelperText id={items.id}>
                            {errors[items.id]?.message}
                          </FormHelperText>
                        </Grid>
                      ))}
                      <Grid item md={12} xs={12}>
                        <StyledContainerBox>
                          <StyledUploadBox>
                            <StyledChoiceFileText>
                              {file ? file : "آپلود فایل ضمیمه"}
                            </StyledChoiceFileText>
                            <ImUpload />
                          </StyledUploadBox>
                          <TextField
                            type="file"
                            variant="outlined"
                            fullWidth
                            id={file}
                            {...register("file")}
                            error={Boolean(errors.file)}
                            helpertext={errors.file?.message}
                            onChange={(e) => setFile(e.target.files[0].name)}
                          />
                        </StyledContainerBox>
                      </Grid>
                      <Grid
                        item
                        md={12}
                        xs={12}
                        style={{ direction: "ltr", paddingTop: "0px" }}
                      >
                        <Button
                          color="success"
                          startIcon={<CheckIcon />}
                          variant="contained"
                          sx={{ mt: 2 }}
                          onClick={handleSubmit(onSubmit)}
                          style={{ direction: "rtl" }}
                        >
                          ثبت تیکت
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Paper>
              </Grid>
            </Grid>
          </Container>

          <FooterCM />
        </>
      )}
    </>
  );
}
